import { computed, inject, Injectable, signal } from '@angular/core';
import { HolidayService } from '../../shared/services/holiday.service';
import { HolidayTypes } from '../../shared/enums/holiday-types.enum';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class HolidayDataService {
  private holidayService = inject(HolidayService);

  private _holidaysData = signal<Record<HolidayTypes, string>>({
    [HolidayTypes.Profile]: './assets/images/pepsico-icons-menu1.png',
    [HolidayTypes.Cart]: './assets/images/pepsico-icons-menu2.png',
    [HolidayTypes.Banner]: './assets/images/perfilbg1.jpg',
  });

  holidaysData = computed(() => this._holidaysData());

  constructor() {
    this.getHolidays();
  }

  private getHolidays() {
    this.holidayService.getHolidays().subscribe({
      next: (response) => {
        response.forEach((holiday) => {
          const key = holiday.typeId as HolidayTypes;
          if (key in this.holidaysData()) {
            this.holidaysData()[
              key
            ] = `${environment.apiUrl}/${holiday.imagePath}`;
          }
        });
      },
    });
  }
}
